import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=8c16b30e&scoped=true&"
import script from "./AdDetails.vue?vue&type=script&lang=js&"
export * from "./AdDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c16b30e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c16b30e')) {
      api.createRecord('8c16b30e', component.options)
    } else {
      api.reload('8c16b30e', component.options)
    }
    module.hot.accept("./AdDetails.vue?vue&type=template&id=8c16b30e&scoped=true&", function () {
      api.rerender('8c16b30e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/Ad/AdDetails.vue"
export default component.exports